<template>
<div class="chapter">
<div class="inner_page">
<h2 id="c4"><span class="calibre1">CHAPTER IV</span>
<br class="calibre8"/>
<span class="h2line">ON A CHOWDER PARTY</span></h2>
<p class="calibre3">“I’ve got a little trip out of town for you,
Larry,” said Mr. Emberg the next morning.
“There will not be much work attached to it,
unless something unexpected happens.”</p>
<p class="calibre3">“What sort of an assignment is it?” asked
Larry.</p>
<p class="calibre3">“The Eighth Ward Democratic Club is going
to have an outing to Coney Island,” replied the
city editor. “It’s a clam chowder party, and,
while it is mainly to give the members of the
association a good time, there may be some politics
discussed.”</p>
<p class="calibre3">“I’m afraid I don’t know much about politics,”
answered Larry, somewhat doubtful of his ability
to cover that kind of an assignment.</p>
<p class="calibre3">“You’ll never learn any younger,” was Mr.
Emberg’s rejoinder, as he smiled at Larry. “Get
me a good story of what the men do, and I guess
you’ll not miss much. There are going to be
some games down at the beach, in the afternoon,
races and so on, that may make something funny
to write about.”</p>
<p class="calibre3">Mr. Emberg gave Larry a ticket to the chowder
outing, and told him where to take the boat.</p>
<div class="calibre2" id="Page_29" title="29"></div>
<p class="calibre3">“You’re in luck, kid,” remarked one of the
older reporters, as he saw the “cub” start on his
assignment.</p>
<p class="calibre3">“How so?” asked Larry.</p>
<p class="calibre3">“Why, there’s nothing to do except enjoy the
trip, eat a good dinner, and sit off in the shade
in the afternoon. It’s one of the few decent
things we fall into in this business.”</p>
<p class="calibre3">“Well, if I can get a good story that’s all I
care about,” responded Larry, who had not been
a reporter long enough to lose his early enthusiasm.
He was always looking for a chance to get
a good story, and no less on this occasion when
there was not much of an opportunity.</p>
<p class="calibre3">Larry made his way to the dock whence the
boat was to leave. He found a crowd of men at
the wharf, all of them wearing gaily-colored
badges, for the Eighth Ward Democratic Club
was one of the most influential and largest political
organizations in New York.</p>
<p class="calibre3">At the dock all was hurry and excitement. A
band was playing lively airs, and a number of fat
men were wiping the perspiration from their
brows, for it was August, and a hot day, and they
had marched half-way around the ward before
coming to the boat.</p>
<div class="calibre2" id="Page_30" title="30"></div>
<p class="calibre3">Scores of men were piling good things to eat
on the boat, for political outings seem to be always
regarded as hungry affairs. Larry saw a
number of other reporters whom he knew slightly,
and spoke to them. Soon all the newspaper men
formed a crowd among themselves, and found a
comfortable place on the boat, where they sat
and talked “shop.”</p>
<p class="calibre3">The older reporters discussed politics, and the
younger ones conversed about the assignments
they had recently covered. For, curiously
enough, though a reporter sees much of life of
various sorts that might furnish topics of conversation,
no sooner do two or more of them
get together than they begin discussions of matters
connected directly with their work. Perhaps
this is so because everything in life concerns
reporters, more or less.</p>
<p class="calibre3">Lunch was served on the boat when it was
about half-way to the Island, and Larry thought
he never had tasted anything so good, for the salt
air made him very hungry. Then such a dinner
as there was when the grove where the club held
its outings was reached.</p>
<p class="calibre3">There was a regular old-fashioned clam chowder
and clam-bake in preparation. First came
the chowder, which, instead of taking the edges
from sharp appetites, seemed only to increase
them. Then the members of the club and their
friends strolled about, sat under trees, or gathered
in little groups to talk, while the clam-bake
was being made ready.</p>
<p class="calibre3">Larry thought perhaps he had better go about,
and see if he could pick up any political tips. He
spoke about it to one of the other reporters, but
the latter said:</p>
<div class="calibre2" id="Page_31" title="31"></div>
<p class="calibre3">“There, now, don’t worry about that, Larry.
The only time when politics will crop out, if
they do at all, is after they’ve had their dinners.
That will loosen their tongues, and we may pick
up something.”</p>
<p class="calibre3">So Larry decided he might spend some time
watching the men prepare the clam-bake.</p>
<p class="calibre3">First they built a big fire of wood in a sort of
hollow in the ground. The blaze was so hot it
was most uncomfortable to go close to it, but the
cook and his assistants did not appear to mind it.
They put scores of stones in the blaze, and the
cobbles were soon glowing with the heat. Occasionally
one would crack, and the pieces flew
all about.</p>
<p class="calibre3">“Ever get hit?” asked Larry, of the cook.</p>
<p class="calibre3">“Once or twice, but I’m getting so I can dodge
’em now.”</p>
<p class="calibre3">Just then came another crack, and the cook
ducked quickly, as a large piece of stone flew over
his head. He laughed, and Larry joined him.
When the stones were hot enough the men raked
away the charred wood and embers, and then
piled the stones up in a round heap. They were
so hot that the men had to use long-handled rakes
and pitchforks.</p>
<div class="calibre2" id="Page_32" title="32"></div>
<p class="calibre3">On top of the cobbles was thrown a quantity
of wet seaweed, which sent up a cloud of vapor.
Then the cook and his helpers began piling on
top of the steaming weed bushels of clams, scores
of lobsters, whole chickens, crabs, potatoes, corn
on the cob, and other things. Then the whole
mass was covered with more seaweed, and over
all a big canvas was spread.</p>
<p class="calibre3">“There, now, it will cook in about an hour,”
said the cook, who seemed to have removed considerable
anxiety from his mind.</p>
<p class="calibre3">“Don’t you build more fire on it?” asked Larry,
who had never been at a clam-bake.</p>
<p class="calibre3">“Not a bit. The hot stones do all the cooking
now,” responded the cook.</p>
<p class="calibre3">And so it proved, for in about an hour the
canvas was taken off, the weed removed, and
there the whole mass of victuals was cooked to
a turn. The men gathered around the table,
places were found for the reporters, and the feast
began. Larry ate so many clams, and so much
lobster and chicken, that he feared he would not
be able to hold a pencil to take notes, providing
anyone was left alive to write about. Everyone
seemed to be trying to outdo his neighbor in the
amount of food consumed.</p>
<p class="calibre3">But it was a healthful way in which to dine,
and no ill effects seemed to follow the clam-bake.
An hour’s rest in the shade followed, and then it
was announced that the games would be started.</p>
<p class="calibre3">A sack race was the first on the programme,
and the contestants, of whom there were eight,
allowed themselves to be tied up in bags, which
reached to their necks. At the word they started
to waddle toward the goal.</p>
<div class="calibre2" id="Page_33" title="33"></div>
<p class="calibre3">There was one very fat man and one thin one
who seemed to be doing better than any of the
others. They both took little steps inside the
bags, and were distancing their competitors.</p>
<p class="calibre3">“Go it, Fatty!” called the stout man’s friends.</p>
<p class="calibre3">“You’ll win, Skinny!” shouted the advocates
of the tall, thin one.</p>
<p class="calibre3">The latter began to forge ahead, and, it seemed,
would win the race.</p>
<p class="calibre3">“Lie down and roll!” shouted someone to the
fat man.</p>
<p class="calibre3">“Dot’s a good ideaness!” answered the fleshy
contestant, who spoke with a strong German accent.</p>
<p class="calibre3">He fell upon his knees, and then toppled over
on his side on the green grass over which the
course was laid. There was a general laugh,
most persons thinking the man had fallen, and
was out of the race. But not so with the fleshy
one. He began rolling over and over, his rotundity
and the soft sod preventing him from
being hurt. He kept his head away from the
ground, and, so rapidly did he revolve that, inside
of two minutes he had passed the thin man.
The latter in his efforts to come in first took too
long steps, his feet got tangled up inside the sack,
and he went sprawling on his face.</p>
<p class="calibre3">“I vins!” exclaimed the German, as he rolled
over for the last time, and bumped into the goal
post.</p>
<p class="calibre3">“You didn’t win fair!” cried the thin man, trying
to talk with his mouth filled with grass.</p>
<div class="calibre2" id="Page_34" title="34"></div>
<p class="calibre3">“Shure I dit!” the fleshy one exclaimed.
“Vat’s der rules?”</p>
<p class="calibre3">“That’s right, he wins under the rules,” announced
the man in charge of the games. “Contestants
could walk, run, or roll. Fatty wins and
gets the prize.”</p>
<p class="calibre3">“Vot iss dot prize?” asked the German, while
some of his friends took him out of the bag.</p>
<p class="calibre3">“This beautiful medal,” replied the man in
charge, and he handed the winner a large one
made of leather, on which was burned a picture
of a donkey. There was a burst of laughter, in
which the butt of the joke had to join.</p>
<p class="calibre3">After this came a potato race, in which each
contestant had to carry the tubers one at a time,
in a spoon, and the one who brought the most to
the goal received five dollars. Following there
was a wheelbarrow contest, in which the smallest
members of the club were obliged to wheel the
largest and fattest ones. It was hard on the thin
men, but the others appeared to enjoy it.</p>
<p class="calibre3">A swimming race to see who could catch a
greased duck caused lots of fun. The men put
on bathing suits, and scores of them went into
the water.</p>
<div class="calibre2" id="Page_35" title="35"></div>
<p class="calibre3">“Don’t some of you reporters want to join the
sport?” asked one of the entertainment committee.
Some of the newspaper men did, and said
so. Larry resolved to enter, for he was a good
swimmer. Soon he had borrowed a suit, and was
splashing around with the others. All was in
readiness for the contest. The duck was released
at the far side of a small cove, the swimmers
starting from the opposite shore.</p>
<p class="calibre3">Such shouting, laughing, splashing, and sport
as there was! Half the men had no intention of
catching the duck, but, instead, took the opportunity
of ducking some of their companions under
water. Larry had no idea of catching the
fowl, since he saw several men try, and lose their
grip because of the oil on the duck’s feathers.</p>
<p class="calibre3">“Five dollars to whoever catches the bird!”
shouted a man on shore, watching the struggle.
At this there was a general rush for the unfortunate
fowl. She was caught once or twice, but
managed to slip away, leaving a few feathers
behind.</p>
<p class="calibre3">“I’m going to catch her,” said Larry to himself.
He waited a good opportunity when the
duck was in a comparatively free space in the
water. Then Larry began swimming slowly
toward her. The duck did not see him approaching,
and was paddling about. When about ten
feet away Larry dived, and began swimming under
water. He rose right under the duck, grabbed
the fowl by the legs, and held her fast, swimming
toward shore with his free arm.</p>
<p class="calibre3">A cheer greeted him as he waded out with the
prize.</p>
<p class="calibre3">“There’s your money!” exclaimed the man
who offered it, handing Larry a five-dollar gold
piece.</p>
<div class="calibre2" id="Page_36" title="36"></div>
<div class="pg-boilerplate" id="calibre_pb_2"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0008.vue?352ae155